/**
 * Reads a persisted boolean flag that may have been stored as a string.
 *
 * Adjustment entries live in `reimbursement_deductions.reimbursementsDeductions[]`,
 * a schema-less array. Forms post them through `FormData`, so `false` used to be
 * persisted as the string `"false"` — which is truthy, so `value || false` would
 * render an unchecked box as checked. Use this instead of raw truthiness when
 * hydrating a form from a saved record.
 */
export const isFlagOn = (value: unknown): boolean =>
  value === true || value === "true" || value === 1 || value === "1";
